<template>
  <b-overlay :show="showoverlay" rounded="sm" class="full-overlay">
    <div class="pt-3">
      <template v-if="showfilter">
        <div class="ibox clearfix">
          <div class="row col-md-12 no-margin head_blue_radius">
            <div class="col-9">
              <div class="pt-3 pb-3 text-left">
                <span>Current Selected: </span>
                <strong class="susd-head">{{ title }}</strong>
              </div>
            </div>
          </div>

            <!-- Report Period Section -->
            <div class="row col-md-12 no-margin">

                <div class=" col-4 ">
                        <period-selector
                        section-title="Report Period"
                        section-id="report"
                        @dates-changed="onDatesChanged"
                    />
                </div>
                <div class=" col-4 ">
                 
                </div>
                
                <div class=" col-4 ">
                    <div class="row no-margin pt-4 pb-3">
                        <div class="col-12 text-right pt-5">
                          <!-- Mustafijur: 24-06-2026: Start -->
                          <!-- <b-button class="custom-wizard-btn float-right" type="submit" variant="primary"
                          @click="generateReport()"><b-icon icon="file-earmark-excel" class="mr-2"></b-icon>Download
                          Report</b-button> -->

                          <b-button
                              type="submit"
                              variant="primary"
                              size="lg"
                              @click="generateReport(1)"
                              style="width: fit-content;">
                              <b-icon icon="filter" style="margin: 0px 5px;"></b-icon>
                              Download Report
                          </b-button>
                          <!-- Mustafijur: 24-06-2026: End -->
                        </div>
                    </div>   
                </div>
            </div>
        </div>


      </template>
    </div>
  </b-overlay>
</template>

<script>
export default {
  props: ['pageurl', 'is_audit', 'audit_id','selected_reporttype','title'],
  data() {
    return {
      showoverlay: false,
      showfilter: false,
      showreport: false,
      report_data: [],
      report_from_date:'',
      report_to_date:'',
    };
  },
  created() {
    this.showfilter = true;
  },
  methods: {
   
    onDatesChanged(data) {
        if (data.sectionId === 'report') {
            this.report_from_date = data.fromDate;
            this.report_to_date = data.toDate;
        }
    },

   
    generateReport() {
      this.$validator.validateAll().then(valid => {
        if (!valid) return;
        
        let formData = new FormData();
        
        if(this.is_audit == 1) {   
            formData.append("audit_id", this.audit_id);
        }
        
        formData.append("start_date", this.report_from_date);
        formData.append("end_date", this.report_to_date);

        this.showoverlay = true;

        const config = {
          headers: { 'Content-Type': 'application/json; charset=utf-8' },
          responseType: 'blob'
        };

        axios.post(this.$api_url + '/pf/report/aging-schedule-peyable-to-outgoing-members', formData, config)
          .then(response => {
            const contentDisposition = response.headers['content-disposition'];
            let fileName = 'Aging_Schedule_Payable_to_Outgoing_Members.xlsx';
            
            if (contentDisposition) {
              const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
              if (fileNameMatch && fileNameMatch[1]) {
                fileName = fileNameMatch[1].replace(/['"]/g, '');
              }
            }
            
            const blob = new Blob([response.data], { type: response.headers['content-type'] });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(link.href);
            this.showoverlay = false;
          })
          .catch(error => {
            this.serverError(error);
            this.showoverlay = false;
          });
      });
    },
  },
 
};
</script>

<style scoped>
.full-overlay {
  height: 100% !important;
}
</style>
